const Fonts = {
    SANS_SERIF: 'Sans Serif',
    SERIF: 'Serif',
    HANDWRITING: 'Handwriting',
    MARKER: 'Marker',
    CURLY: 'Curly',
    PIXEL: 'Pixel',
    PLAYFUL: 'Playful',
    BUBBLY: 'Bubbly',
    BITSANDBYTES: 'Bits and Bytes',
    TECHNOLOGICAL: 'Technological',
    ARCADE: 'Arcade',
    ARCHIVO: 'Archivo',
    ARCHIVOBLACK: 'Archivo Black',
    SCRATCH: 'Scratch',
    CHINESE: '"Microsoft YaHei", "微软雅黑", STXihei, "华文细黑"',
    JAPANESE: '"ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic"',
    KOREAN: 'Malgun Gothic'
};

export default Fonts;
